import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

const STORAGE_KEY = 'lastVisitedPage';

export const useLastVisitedPage = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't store login page or error pages
    if (!location.pathname.includes('login') && !location.pathname.includes('error')) {
      localStorage.setItem(STORAGE_KEY, location.pathname);
    }
  }, [location]);

  const getLastVisitedPage = () => {
    return localStorage.getItem(STORAGE_KEY) || '/dashboard';
  };

  return { getLastVisitedPage };
};
